import { AiIcon, Chip, ChipProps } from '@farol-ds/react'
import { ChipKindEnum } from '@jusbrasil-web/shared-apollo-client/types'
import classNames from 'classnames'

import styles from './info-chip.module.scss'

export interface InfoChipProps {
  label: string
  kind?: ChipKindEnum | null
  size?: ChipProps['size']
  className?: string
}

export function InfoChip({ label, kind, size = 'md', className }: InfoChipProps) {
  return (
    <Chip
      size={size}
      kind={kind ?? ChipKindEnum.Info}
      leftIcon={<AiIcon />}
      className={classNames(styles.root, className)}
    >
      {label}
    </Chip>
  )
}
